import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import ForgotPasswordLink from './ForgotPasswordLink.vue';
import TrackingService from '@/core/tracking.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyAccountLoginForm',
  props: {
    userNameText: { default: 'Username' },
    passwordText: { default: 'Password' },
    loginButtonText: { default: 'Submit' },
    forgotPasswordText: null,
    forgotPasswordLink: null,
    showSpinner: { type: Boolean },
    loginErrorMessage: null
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const formData = ref<ILoginForm>({
    username: '',
    password: ''
});




const onSubmit = async() => {
    TrackingService.event('Login', 'Submit');
    emit('submit', formData.value);
};

return { __sfc: true,formData, emit, onSubmit, ForgotPasswordLink }
}

})